<div>
  <form [formGroup]="formNoteDetail">
    <div class="row p-1">
      <div class="col field-article">
        <app-custom-inputgroup [inputValue]="codeNameArticle" [labelText]="'Artículo'"
          [iconButton]="'pi pi-external-link'" [titleButton]="'Seleccionar artículo'" [required]="true"
          (onClick)="openArticleModal()"></app-custom-inputgroup>
        <app-custom-modal #selectArticle [label]="'Nuevo'" [header]="'Selección de Articulos'"
          [inputs$]="inputsForArticlesSelect$" [output$]="output$" [children]="component"
          (selectedItems)="handleSelectedItems($event)" hidden></app-custom-modal>
      </div>
      <div class="col field-unit-value">
        <app-custom-input-decimal formControlName="unitValueInvoiced"
          [labelText]="'Vr Unit.Fact.'"></app-custom-input-decimal>
      </div>
      <div class="col field-quantity-invoiced">
        <app-custom-input-decimal formControlName="quantityInvoiced"
          [labelText]="'Cant.Fact.'"></app-custom-input-decimal>
      </div>
      <div class="col field-total-value-invoiced">
        <app-custom-input-decimal formControlName="totalValueInvoiced"
          [labelText]="'Total Fact.'"></app-custom-input-decimal>
      </div>
      <div class="col field-quantity">
        <app-custom-input-decimal formControlName="quantity" [labelText]="'Cantidad'" [required]="true"
          (onChangeNumber)="changeQuantity($event)"></app-custom-input-decimal>
      </div>
      <div class="col field-total-value">
        <app-custom-input-decimal formControlName="totalValue" [labelText]="'Valor Total'" [required]="true"
          (onChangeNumber)="changeTotalValue($event)"></app-custom-input-decimal>
      </div>
      <div class="col field-iva-base">
        <app-custom-input-decimal formControlName="ivaBase" [labelText]="'Base IVA'"></app-custom-input-decimal>
      </div>
      <div class="col field-iva-rate">
        <app-custom-input-decimal formControlName="ivaRate" [labelText]="'% IVA'"></app-custom-input-decimal>
      </div>
      <div class="col field-buttons d-flex">
        <div class="d-flex align-items-end justify-content-end gap-2 container-buttons bottom-0">
          <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [variant]="undefined" [disabled]="disableSave"
            (onClick)="send()"></app-custom-button>
          <app-custom-button [label]="'Cancelar'" [severity]="'danger'" [disabled]="disableSave"
            (onClick)="clearForm()"></app-custom-button>
        </div>
      </div>
    </div>
  </form>
</div>